import React, { useEffect, useState, useCallback, useMemo, Suspense, lazy } from 'react';
import Modal from '../../../common/modal';
import { Item } from '../../../common/snippets';
import { Box, Tab, Tabs } from '@mui/material';
import { BranchPageTab, BranchPageTabIds, BrnhTypeOpt, BrnhStatusOpt, GstModalObject, BranchBusObject, BrnchCargoConfigObject, BranchReportObject, BrnhDirectoryObject, BrnchOtherCargoConfigObject, BranchPageTabFromURL } from './BrnchMasterConstant';
import { removeDuplicatesFromArray } from '../../../common/helper';
import BranchCargoOtherConfig from './BranchCargoOtherConfig';
import BrnhBusConfig from './Modal/BrnhBusConfig';
import { getBranchData, getBranchMaster, getGSTNValidation, updateBranchBusData } from '../../../../store/branchAndUserMaster/BUMAction';

// Lazy load modal content components
const BranchDetails = lazy(() => import('./Modal/BranchDetails'));
const BranchCargoConfig = lazy(() => import('./Modal/BranchCargoConfig'));
const BrnhReportConfig = lazy(() => import('./Modal/BrnhReportConfig'));
const BrnhDirectoryConfig = lazy(() => import('./Modal/BrnhDirectoryConfig'));

const BrnchMasterModal = ({ data, updateModal, updateModalHeaderDropDownData, FromUrlRedirect, loginData }) => {
    const { headText, BranchId, isEdit, BranchList, stateList, cityList } = data;
    const modalStyle = useMemo(() => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingTop: "24px"
    }), []);

    const [selectedTab, setSelectedTab] = useState(0);

    // Branch Details
    const [brnhDetailsData, setBrnhDetailsData] = useState({
        BranchID: 0,
        BranchName: "",
        BranchCode: "",
        BranchManagerName: "",
        ContactNo1: "",
        ContactNo2: "",
        ContactLocal: "",
        EmailID: "",
        Address: "",
        Pincode: '',
        IsActive: 0
    });
    const [selState, setSelState] = useState('');
    const [selCity, setSelCity] = useState('');
    const [cityOpt, setCityOpt] = useState([]);
    const [selBrnhType, setSelBrnhType] = useState(BrnhTypeOpt[2]);
    const [selBrnhStatus, setSelBrnhStatus] = useState(BrnhStatusOpt[0]);

    // Bus Config
    const [branchBusValue, setBranchBusValue] = useState(BranchBusObject);
    const [brnhBusGST, setBrnhBusGST] = useState(GstModalObject);

    // Cargo Config
    const [tableData, setTableData] = useState([]);
    const [brnhCargoValue, setBrnchCargoValue] = useState(BrnchCargoConfigObject);
    const [selCargoAccBrnhOpt, setSelCargoAccBrnhOpt] = useState([]);
    const [brnhCargoGST, setBrnhCargoGST] = useState(GstModalObject);

    // Branch Report
    const [brnchReportValue, setBrnchReportValue] = useState(BranchReportObject);

    // Branch Directory
    const [brnhDirectoryValue, setBrnhDirectoryValue] = useState(BrnhDirectoryObject);
    //Branch Other Config
    const [brnhOtherCargoValue, setBrnchOtherCargoValue] = useState(BrnchOtherCargoConfigObject);
    const [selOtherCargoAccBrnhOpt, setSelOtherCargoAccBrnhOpt] = useState([]);
    const [brnhOtherCargoGST, setBrnhOtherCargoGST] = useState(GstModalObject);

    useEffect(() => {
        if (BranchList.length > 0) {
            const defaultBranch = isEdit
                ? BranchList.find(val => val.BranchID === BranchId)
                : BranchList[0];
            if (defaultBranch) {
                defualtAllValue(defaultBranch);
            }
        }
    }, [BranchList, isEdit, BranchId]);

    const defualtAllValue = useCallback((defaultBranch) => {
        const stateList = removeDuplicatesFromArray(BranchList, "StateID");
        const cityList = removeDuplicatesFromArray(BranchList.filter(val => val.StateID === defaultBranch.StateID), "CityID");
        const branchList = removeDuplicatesFromArray(BranchList.filter(val => val.CityID === defaultBranch.CityID), 'BranchID');
        updateModalHeaderDropDownData({
            stateOpt: stateList,
            selState: defaultBranch,
            cityOpt: cityList,
            selCity: defaultBranch,
            branchOpt: branchList,
            selBranch: defaultBranch,
            branchCode: defaultBranch.BranchCode,
        });
    }, [BranchList, updateModalHeaderDropDownData]);

    const [tabData, setTabData] = useState({
        isChgTab: false,
        isnextValue: 0
    });

    const [confModal, setConfModal] = useState({
        branchDetails: false,
        branchBus: false,
        branchCargo: false,
        branchReport: false,
        branchDirectory: false,
        branchOtherConfig: false
    });

    const [isDisableBtn, setIsDisableBtn] = useState({
        branchDetails: false,
        branchBus: false,
        branchCargo: false,
        branchReport: false,
        branchDirectory: false,
        branchOtherConfig: false
    });

    const resetAllValueBrnhMaster = useCallback(() => {
        setBranchBusValue(BranchBusObject);
        setBrnchCargoValue(BrnchCargoConfigObject);
        setTableData([]);
        setSelCargoAccBrnhOpt([]);
        setBrnchReportValue(BranchReportObject);
        setBrnhDirectoryValue(BrnhDirectoryObject);
        setBrnchOtherCargoValue(BrnchOtherCargoConfigObject)
        setBrnhOtherCargoGST(GstModalObject);
        setBrnhCargoGST(GstModalObject);
        setBrnhBusGST(GstModalObject);
        setConfModal({
            branchDetails: false,
            branchBus: false,
            branchCargo: false,
            branchReport: false,
            branchDirectory: false
        });
        setIsDisableBtn({
            branchDetails: false,
            branchBus: false,
            branchCargo: false,
            branchReport: false,
            branchDirectory: false,
        });
    }, []);

    const handleTabChange = useCallback((e, newValue) => {
        if (Object.values(confModal).some(item => item)) {
            setTabData({ ...tabData, isChgTab: true, isnextValue: newValue });
        } else {
            setSelectedTab(newValue);
            setTabData({ ...tabData, isChgTab: false, isnextValue: newValue });
        }
    }, [confModal, tabData]);

    const getBookingPageContent = useCallback((typeId, label) => {
        switch (label) {
            case 'BRANCH Details':
                return (
                    <BranchDetails
                        selCity={selCity}
                        setSelCity={setSelCity}
                        cityOpt={cityOpt}
                        setCityOpt={setCityOpt}
                        selBrnhType={selBrnhType}
                        setSelBrnhType={setSelBrnhType}
                        selBrnhStatus={selBrnhStatus}
                        setSelBrnhStatus={setSelBrnhStatus}
                        brnhDetailsData={brnhDetailsData}
                        setBrnhDetailsData={setBrnhDetailsData}
                        selState={selState}
                        setSelState={setSelState}
                        setTabData={setTabData}
                        updateModal={updateModal}
                        propsData={data}
                        confModal={confModal}
                        setConfModal={setConfModal}
                        setSelectedTab={setSelectedTab}
                        tabData={tabData}
                        BranchList={BranchList}
                        loginData={loginData}
                    />
                );
            case 'Branch Cargo Config.':
                return (
                    <BranchCargoConfig
                        BranchList={BranchList}
                        setTabData={setTabData}
                        brnhCargoGST={brnhCargoGST}
                        setBrnhCargoGST={setBrnhCargoGST}
                        resetAllValueBrnhMaster={resetAllValueBrnhMaster}
                        isDisableBtn={isDisableBtn}
                        setIsDisableBtn={setIsDisableBtn}
                        tableData={tableData}
                        setTableData={setTableData}
                        brnhCargoValue={brnhCargoValue}
                        setBrnchCargoValue={setBrnchCargoValue}
                        selCargoAccBrnhOpt={selCargoAccBrnhOpt}
                        setSelCargoAccBrnhOpt={setSelCargoAccBrnhOpt}
                        updateModal={updateModal}
                        confModal={confModal}
                        setConfModal={setConfModal}
                        setSelectedTab={setSelectedTab}
                        tabData={tabData}
                        loginData={loginData}
                    />
                );
            // case 2:
            //     return (
            //         <BrnhReportConfig
            //             setTabData={setTabData}
            //             resetAllValueBrnhMaster={resetAllValueBrnhMaster}
            //             isDisableBtn={isDisableBtn}
            //             setIsDisableBtn={setIsDisableBtn}
            //             brnchReportValue={brnchReportValue}
            //             setBrnchReportValue={setBrnchReportValue}
            //             updateModal={updateModal}
            //             confModal={confModal}
            //             setConfModal={setConfModal}
            //             setSelectedTab={setSelectedTab}
            //             tabData={tabData}
            //             loginData={loginData}
            //         />
            //     );
            case 'Branch Cargo Other Config.':
                return (
                    <BranchCargoOtherConfig
                        BranchList={BranchList}
                        resetAllValueBrnhMaster={resetAllValueBrnhMaster}
                        brnhOtherCargoGST={brnhOtherCargoGST}
                        setBrnhOtherCargoGST={setBrnhOtherCargoGST}
                        brnhOtherCargoValue={brnhOtherCargoValue}
                        setBrnchOtherCargoValue={setBrnchOtherCargoValue}
                        selOtherCargoAccBrnhOpt={selOtherCargoAccBrnhOpt}
                        setSelOtherCargoAccBrnhOpt={setSelOtherCargoAccBrnhOpt}
                        updateModal={updateModal}
                        setSelectedTab={setSelectedTab}
                        tabData={tabData}
                        isDisableBtn={isDisableBtn}
                        setIsDisableBtn={setIsDisableBtn}
                        confModal={confModal}
                        setConfModal={setConfModal}
                        setTabData={setTabData}
                        loginData={loginData}
                    />
                );
            case 'Branch Directory Config.':
                return (
                    <BrnhDirectoryConfig
                        setTabData={setTabData}
                        resetAllValueBrnhMaster={resetAllValueBrnhMaster}
                        isDisableBtn={isDisableBtn}
                        setIsDisableBtn={setIsDisableBtn}
                        brnhDirectoryValue={brnhDirectoryValue}
                        setBrnhDirectoryValue={setBrnhDirectoryValue}
                        updateModal={updateModal}
                        confModal={confModal}
                        setConfModal={setConfModal}
                        setSelectedTab={setSelectedTab}
                        tabData={tabData}
                        setSelCargoAccBrnhOpt={setSelCargoAccBrnhOpt}
                        loginData={loginData}
                    />

                );
            case 'Branch Bus Config.':
                return (
                    <BrnhBusConfig
                        getBranchData={getBranchData}
                        updateBranchBusData={updateBranchBusData}//
                        getGSTNValidation={getGSTNValidation}//
                        setSelectedTab={setSelectedTab}
                        tabData={tabData}
                        confModal={confModal}
                        setConfModal={setConfModal}
                        updateModal={updateModal}
                        getBranchMaster={getBranchMaster}//
                        branchBusValue={branchBusValue}
                        setBranchBusValue={setBranchBusValue}
                        isDisableBtn={isDisableBtn}
                        setIsDisableBtn={setIsDisableBtn}
                        resetAllValueBrnhMaster={resetAllValueBrnhMaster}
                        brnhBusGST={brnhBusGST}
                        setBrnhBusGST={setBrnhBusGST}
                        setTabData={setTabData}
                        loginData={loginData}
                    />

                );

            case 'Branch Report Config':
                return (
                    <BrnhReportConfig
                        setTabData={setTabData}
                        resetAllValueBrnhMaster={resetAllValueBrnhMaster}
                        isDisableBtn={isDisableBtn}
                        setIsDisableBtn={setIsDisableBtn}
                        brnchReportValue={brnchReportValue}
                        setBrnchReportValue={setBrnchReportValue}
                        updateModal={updateModal}
                        confModal={confModal}
                        setConfModal={setConfModal}
                        setSelectedTab={setSelectedTab}
                        tabData={tabData}
                        loginData={loginData}
                    />

                );
            default:
                return label;
        }
    }, [
        selCity, cityOpt, selBrnhType, selBrnhStatus, brnhDetailsData,
        selState, setTabData, updateModal, data, confModal,
        setConfModal, setSelectedTab, tabData, BranchList,
        brnhCargoGST, resetAllValueBrnhMaster, isDisableBtn,
        setIsDisableBtn, tableData, setTableData, brnhCargoValue,
        setBrnchCargoValue, selCargoAccBrnhOpt, setSelCargoAccBrnhOpt,
        brnchReportValue, setBrnchReportValue, brnhDirectoryValue,
        setBrnhDirectoryValue, brnhOtherCargoValue, setBrnchOtherCargoValue,
        selOtherCargoAccBrnhOpt, setSelOtherCargoAccBrnhOpt
    ]);

    return (
        <Modal
            headTxt={headText}
            width={'92%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <Box className="BranchPageTabContainer scrollBlue" sx={{ maxHeight: '85vh', overflowY: 'auto' }}>
                <Item sx={{ paddingTop: 0, paddingX: 0, minHeight: '310px' }}>
                    <Box sx={{
                        paddingX: '15px', borderBottom: 1, borderColor: 'divider', backgroundColor: '#F2F9FF !important',
                        position: 'sticky',
                        top: 0,
                        zIndex: 6,
                    }}>
                        <Tabs
                            value={selectedTab}
                            variant="scrollable"
                            aria-label="basic tabs example"
                            sx={{ minHeight: 'unset', alignItems: 'center' }}
                            onChange={handleTabChange}
                        >
                            {(FromUrlRedirect ? BranchPageTabFromURL : BranchPageTab).map((reqType, index) => (
                                <Tab key={`sender_${index}`} label={reqType} {...BranchPageTabIds(index)} />
                            ))}
                        </Tabs>
                    </Box>
                    {(FromUrlRedirect ? BranchPageTabFromURL : BranchPageTab).map((reqType, index) => (
                        <div
                            role="tabpanel"
                            hidden={selectedTab !== index}
                            id={`bookingPage-tabpanel-${index}`}
                            aria-labelledby={`bookingPage-tab-${index}`}
                            key={`senderSe_${index}`}
                        >
                            <Suspense fallback={<div style={{ margin: 'auto' }}>Loading...</div>}>
                                {selectedTab === index && <Box>{getBookingPageContent(index, reqType)}</Box>}
                            </Suspense>
                        </div>
                    ))}
                </Item>
            </Box>
        </Modal>
    );
};

export default React.memo(BrnchMasterModal);
